import { render, staticRenderFns } from "./workspace-question-view.vue?vue&type=template&id=588a0188&scoped=true"
import script from "./workspace-question-view.vue?vue&type=script&lang=js"
export * from "./workspace-question-view.vue?vue&type=script&lang=js"
import style0 from "./workspace-question-view.vue?vue&type=style&index=0&id=588a0188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588a0188",
  null
  
)

export default component.exports